import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class HostListenerService {
    documentClickedEvent$ = new Subject<MouseEvent>();
    windowKeydownEvent$ = new Subject<KeyboardEvent>();
    windowKeyupEvent$ = new Subject<KeyboardEvent>();
    windowScrollEvent$ = new Subject<void>();

    readonly smBreakpoint$ = new BehaviorSubject<boolean>(false);
    readonly mdBreakpoint$ = new BehaviorSubject<boolean>(false);
    readonly lgBreakpoint$ = new BehaviorSubject<boolean>(false);
    readonly xlBreakpoint$ = new BehaviorSubject<boolean>(false);

    // legacy ui mobile break point (max-width: 945)
    // TODO: review in redesign compared to above breakpoints
    readonly isLegacySmBreakpoint$ = new BehaviorSubject<boolean>(false);

    onMouseClick() {
        return this.documentClickedEvent$.asObservable();
    }

    onKeydown() {
        return this.windowKeydownEvent$.asObservable();
    }

    onKeyup() {
        return this.windowKeyupEvent$.asObservable();
    }

    onScroll() {
        return this.windowScrollEvent$.asObservable();
    }

    isMobileMode() {
        return this.smBreakpoint$.asObservable();
    }

    isLegacyMobileMode() {
        return this.isLegacySmBreakpoint$.asObservable();
    }

    isTabletMode() {
        return this.mdBreakpoint$.asObservable();
    }

    isDesktopMode() {
        return this.lgBreakpoint$.asObservable();
    }

    isLargerDesktopMode() {
        return this.xlBreakpoint$.asObservable();
    }
}
